import type { FC } from "react";

import {
  DRAWER_FOOTER_CLASS,
  DRAWER_FIXED_FOOTER_CONTAINER_CLASS,
  DRAWER_FIXED_FOOTER_CLASS,
  DRAWER_FOOTER_ORIENTATION_CLASS_MAP,
  type TDrawerFooterProps,
} from "@/ui/components/overlay/Drawer/Drawer.config";
import { Container } from "@/ui/components/layout/Container";
import { Button } from "@/ui/components/primitives";
import { cn } from "@/ui/lib/utils";

export const DrawerFooter: FC<TDrawerFooterProps> = ({
  actionsOrientation = "vertical",
  actionsPosition = "scrolling",
  className,
  ctas,
  ...props
}) => {
  if (!ctas) { return null; }

  const footerActions = (
    <div
      data-component="DrawerFooterActions"
      className={cn(
        DRAWER_FOOTER_CLASS,
        DRAWER_FOOTER_ORIENTATION_CLASS_MAP[actionsOrientation],
        actionsPosition === "fixed" && DRAWER_FIXED_FOOTER_CONTAINER_CLASS,
      )}
    >
      { ctas.primary ? <Button {...ctas.primary} width="fill" /> : null }
      { ctas.secondary ? (
        <Button {...ctas.secondary} variant="tertiary" width="fill" />
      ) : null }
    </div>
  );

  return (
    <div
      data-component="DrawerFooter"
      className={cn(
        actionsPosition === "fixed" && DRAWER_FIXED_FOOTER_CLASS,
        className,
      )}
      {...props}
    >
      { actionsPosition === "fixed" ? (
        <Container size="md">{ footerActions }</Container>
      ) : footerActions }
    </div>
  );
};

DrawerFooter.displayName = "DrawerFooter";
